import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromTree from '../reducers/tree.reducer';

export const getTreeState = createSelector(
  fromFeature.getProductsState,
  (state: fromFeature.DashboardState) => state.tree
);

export const getTemplatesEntities = createSelector(getTreeState, fromTree.getVelaTemplates);

export const getVelaInput = createSelector(getTreeState, fromTree.getVelaInput);
export const getVelaTemplates = createSelector(getTemplatesEntities, (entities) => {
  return Object.keys(entities).map((name: string) => entities[name]);
});
